import { ExtraValidator } from '@nstep-common/utils';
import { PinConfirmationModel } from '@nstep-public/pages';

export class PinConfirmationModelValidator extends ExtraValidator<PinConfirmationModel> {
	constructor() {
		super();

		this.ruleFor('pin')
			.matches(/^\d{4,6}$/)
			.withMessage('You must specify a valid PIN');
	}
}